/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneContent({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneContent",
  parentRef,
  backgroundColor,
  borderWidth = 1,
  borderColor,
  paddingLeft = 12,
  paddingRight = 12,
  paddingBottom = 5,
  paddingTop = 5,
  height = 30,
  maxWidth,
  width = "100%",
  size,
  dock,
  disabled,
  focused,
  invalid,
  optionsWidth,
  selectedPlaceholder,
  from,
  hovered,
  valid,
  placeholder,
  value,
  isSelected,
  isMultiChoice,
  isSelectedAll,
  onClick,
  onClickToggleAll,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  onChangeFilter,
  valueFilter,
  optionValue,
  onKeyUp,
  isShowingOptions,
  innerRef,
  inputRef,
  fromCustom,
  onClickAddFilterAsCustomOption,
  isShowingAddFilterAsCustomOption,
  selected,
  optionsLeft,
  optionsTop,
  optionsRef,
  showSelectAll
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtTysiainputcontentBackgroundcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.backgroundColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryFocused = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.focused'
        })
let dtTysiainputcontentBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.invalid'
        })
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderColorOrdtColorsNeutral300 = borderColor ?? dtColorsNeutral300
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneContent.Horizontal"
  data-view-path={viewPath}
 ref={parentRef}
 role="listbox"
 tabIndex={-1}
 style={{'--bw-6-1uJchM': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--pl-8-1uJchM': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-9-1uJchM': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--mw-13-1uJchM': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-14-1uJchM': typeof width === 'number' ? `${width}px` : width,'--pb-10-1uJchM': size === "small" ? "4px" : typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pt-11-1uJchM': size === "small" ? "4px" : typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--h-12-1uJchM': size === "small" ? "24px" : typeof height === 'number' ? `${height}px` : height,'--bblr-2-1uJchM': dock === "left" ? "0px" : "4px",'--btlr-4-1uJchM': dock === "left" ? "0px" : "4px",'--bbrr-3-1uJchM': dock === "right" ? "0px" : "4px",'--btrr-5-1uJchM': dock === "right" ? "0px" : "4px",'--bc-1-1uJchM': disabled ? dtTysiainputcontentBackgroundcolorPrimaryDisabled : backgroundColorOrdtColorsWhite,'--bc-7-1uJchM': disabled ? dtTysiainputcontentBordercolorPrimaryDisabled : focused ? dtTysiainputcontentBordercolorPrimaryFocused : invalid ? dtTysiainputcontentBordercolorPrimaryInvalid : borderColorOrdtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 width={optionsWidth}
 selectedPlaceholder={selectedPlaceholder}
 from={from}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 placeholder={placeholder}
 value={value}
 isSelected={isSelected}
 isMultiChoice={isMultiChoice}
 isSelectedAll={isSelectedAll}
 onClick={onClick}
 onClickToggleAll={onClickToggleAll}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 onChangeFilter={onChangeFilter}
 valueFilter={valueFilter}
 optionValue={optionValue}
 onKeyUp={onKeyUp}
 isShowingOptions={isShowingOptions}
 innerRef={innerRef}
 inputRef={inputRef}
 fromCustom={fromCustom}
 onClickAddFilterAsCustomOption={onClickAddFilterAsCustomOption}
 isShowingAddFilterAsCustomOption={isShowingAddFilterAsCustomOption}
 selected={selected}
 optionsLeft={optionsLeft}
 optionsTop={optionsTop}
 optionsRef={optionsRef}
 optionsWidth={optionsWidth}
 showSelectAll={showSelectAll}
>
{children}
</Children>
</div>
</React.Fragment>)
}